
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class TableContenteditable extends Vue {
  @Prop(String) value!: string;

  onEdit(e: any) {
    const value = e.target.innerText;
    this.$emit("input", value);
  }
}
